import { createContext } from "react";

export const FacilitySideBarContext = createContext<{
  showFacilitySidebar: (facilityId?: number) => void;
}>({} as any);
